import { atom } from "recoil";
import {
  MEDICAL_DISCLAIMER_STATE_KEY,
  type MedicalDisclaimerState,
  readMedicalDisclaimerState,
  writeMedicalDisclaimerState,
} from "../utils/medicalDisclaimer";

export const medicalDisclaimerAtom = atom<MedicalDisclaimerState>({
  key: MEDICAL_DISCLAIMER_STATE_KEY,
  default: readMedicalDisclaimerState(),
  effects: [
    ({ onSet }) => {
      onSet((next) => {
        writeMedicalDisclaimerState(next);
      });
    },
  ],
});
